import type { UseInfiniteQueryResult } from "@tanstack/react-query";

export const getPaginatedInfiniteQueryData = <TOutput>(query: UseInfiniteQueryResult<server.dto.ApiResponseWrapper<TOutput[]>>) => 
  query.data?.pages.flatMap(p => p.data ?? []) ?? [];

export const getAbsoluteCountFromPaginatedInfiniteQueryData = <TOutput>(query: UseInfiniteQueryResult<server.dto.ApiResponseWrapper<TOutput[]>>) => {
  const pages = query.data?.pages[0];
  if ("absoluteCount" in (pages ?? {})) {
    // @ts-expect-error absoluteCount exists here
    return pages.absoluteCount as number;
  }

  return null;
}
